export const ERROR_RECEIVE = 'ERROR_RECEIVE'

export const THIRDPAYLOGIN_REQUEST = 'THIRDPAYLOGIN_REQUEST'
export const THIRDPAYLOGIN_RECEIVE = 'THIRDPAYLOGIN_RECEIVE'

export const THIRDPAYDRLOGIN_REQUEST = 'THIRDPAYDRLOGIN_REQUEST'
export const THIRDPAYDRLOGIN_RECEIVE = 'THIRDPAYDRLOGIN_RECEIVE'

export const GETCURRENCYGEAR_REQUEST = 'GETCURRENCYGEAR_REQUEST'
export const GETCURRENCYGEAR_RECEIVE = 'GETCURRENCYGEAR_RECEIVE'

export const GETALLPAYMODE_REQUEST = 'GETALLPAYMODE_REQUEST'
export const GETALLPAYMODE_RECEIVE = 'GETALLPAYMODE_RECEIVE'

export const SERVERIAPLIST_REQUEST = 'SERVERIAPLIST_REQUEST'
export const SERVERIAPLIST_RECEIVE = 'SERVERIAPLIST_RECEIVE'

export const GETTHIRDPAYORDERLIST_REQUEST = 'GETTHIRDPAYORDERLIST_REQUEST'
export const GETTHIRDPAYORDERLIST_RECEIVE = 'GETTHIRDPAYORDERLIST_RECEIVE'

export const CREATETHIRDPAYORDER_REQUEST = 'CREATETHIRDPAYORDER_REQUEST'
export const CREATETHIRDPAYORDER_RECEIVE = 'CREATETHIRDPAYORDER_RECEIVE'

export const VERIFYTHIRDPAYORDER_REQUEST = 'VERIFYTHIRDPAYORDER_REQUEST'
export const VERIFYTHIRDPAYORDER_RECEIVE = 'VERIFYTHIRDPAYORDER_RECEIVE'

export const THIRDPAYORDERREQUESTPAY_REQUEST = 'THIRDPAYORDERREQUESTPAY_REQUEST'
export const THIRDPAYORDERREQUESTPAY_RECEIVE = 'THIRDPAYORDERREQUESTPAY_RECEIVE'

export const GETTHIRDPAYGOODSDETAIL_REQUEST = 'GETTHIRDPAYGOODSDETAIL_REQUEST'
export const GETTHIRDPAYGOODSDETAIL_RECEIVE = 'GETTHIRDPAYGOODSDETAIL_RECEIVE'

export const GETDEFAULTPAYMENT_REQUEST = 'GETDEFAULTPAYMENT_REQUEST'
export const GETDEFAULTPAYMENT_RECEIVE = 'GETDEFAULTPAYMENT_RECEIVE'

export const CHECKROLESTOKEN_REQUEST = 'CHECKROLESTOKEN_REQUEST'
export const CHECKROLESTOKEN_RECEIVE = 'CHECKROLESTOKEN_RECEIVE'

export const ORDERSUBLIST_REQUEST = 'ORDERSUBLIST_REQUEST'
export const ORDERSUBLIST_RECEIVE = 'ORDERSUBLIST_RECEIVE'

export const GETUSERPOINTDATA_REQUEST = 'GETUSERPOINTDATA_REQUEST'
export const GETUSERPOINTDATA_RECEIVE = 'GETUSERPOINTDATA_RECEIVE'

export const GETUSERPOINTRULE_REQUEST = 'GETUSERPOINTRULE_REQUEST'
export const GETUSERPOINTRULE_RECEIVE = 'GETUSERPOINTRULE_RECEIVE'

export const GETUSERPOINTSWITCH_REQUEST = 'GETUSERPOINTSWITCH_REQUEST'
export const GETUSERPOINTSWITCH_RECEIVE = 'GETUSERPOINTSWITCH_RECEIVE'

export const GETEMAILCODE_REQUEST = 'GETEMAILCODE_REQUEST'
export const GETEMAILCODE_RECEIVE = 'GETEMAILCODE_RECEIVE'

export const SETPAYEMAIL_REQUEST = 'SETPAYEMAIL_REQUEST'
export const SETPAYEMAIL_RECEIVE = 'SETPAYEMAIL_RECEIVE'

export const GETPOINTINIT_REQUEST = 'GETPOINTINIT_REQUEST'
export const GETPOINTINIT_RECEIVE = 'GETPOINTINIT_RECEIVE'

export const GETPAYPWDFLAG_REQUEST = 'GETPAYPWDFLAG_REQUEST'
export const GETPAYPWDFLAG_RECEIVE = 'GETPAYPWDFLAG_RECEIVE'

export const GETEMAILFLAG_REQUEST = 'GETEMAILFLAG_REQUEST'
export const GETEMAILFLAG_RECEIVE = 'GETEMAILFLAG_RECEIVE'

export const SETPAYPWD_REQUEST = 'SETPAYPWD_REQUEST'
export const SETPAYPWD_RECEIVE = 'SETPAYPWD_RECEIVE'

export const CHANGEPAYPWD_REQUEST = 'CHANGEPAYPWD_REQUEST'
export const CHANGEPAYPWD_RECEIVE = 'CHANGEPAYPWD_RECEIVE'

export const GETUSERPAYEMAIL_REQUEST = 'GETUSERPAYEMAIL_REQUEST'
export const GETUSERPAYEMAIL_RECEIVE = 'GETUSERPAYEMAIL_RECEIVE'

export const CHECKPAYPWD_REQUEST = 'CHECKPAYPWD_REQUEST'
export const CHECKPAYPWD_RECEIVE = 'CHECKPAYPWD_RECEIVE'

export const CHECKPAYEMAIL_REQUEST = 'CHECKPAYEMAIL_REQUEST'
export const CHECKPAYEMAIL_RECEIVE = 'CHECKPAYEMAIL_RECEIVE'

export const CHECKUPAY_REQUEST = 'CHECKUPAY_REQUEST'
export const CHECKUPAY_RECEIVE = 'CHECKUPAY_RECEIVE'

export const INIT = 'INIT'

export const GETVERSION_REQUEST = 'GETVERSION_REQUEST'
export const GETVERSION_RECEIVE = 'GETVERSION_RECEIVE'
/**
 * center 模块 ParamTrackerCtrl 
 */
export const TRACKLOG_REQUEST = 'TRACKLOG_REQUEST';

export const TRACKLOG_RECEIVE = 'TRACKLOG_RECEIVE';
